import PropTypes from "prop-types"
import { Person } from "@mui/icons-material"
import { connect } from "react-redux"
import { get } from "lodash"
import Header from "modules/home-header"

function TeamDatasetEntitlementsHeader({ account, name }) {
  const teamName = name ? `Team Dataset Entitlements:  ${name}` : "Team Dataset Entitlements"
  return <Header Icon={Person} title={teamName} account={account} />
}

TeamDatasetEntitlementsHeader.propTypes = {
  account: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default connect(state => ({ name: get(state, "global.data.teamDatasetEntitlements.data.team.name") }), null)(TeamDatasetEntitlementsHeader)
